import React, { useEffect, useState } from 'react'
import { Deal } from '../../models/shared/Deal'
import { FormCheck, FormControl, InputGroup, Modal, ModalBody, Spinner } from 'react-bootstrap'
import { useText } from '../../context/TextContext'
import { useFirestore } from 'reactfire'
import CloseButton from '../CloseButton'
import { ShareToken } from '../../models/shared/ShareToken'
import { useOrganization } from '../../context/OrganizationContext'
import { addDoc, collection, doc, setDoc } from 'firebase/firestore'
import { COLLECTIONS } from '../../utils/shared/constants'
import { toast } from 'react-toastify'
import { createShareTokenLink } from '../../utils/shared/links'
import { AdvancedButton } from '../AdvancedButton'

interface Props {
    deal: Deal | null,
    onHide: () => void
}

export default function DealShareModal(props: Props) {
    const text = useText();
    const firestore = useFirestore();
    const [token, setToken] = useState<ShareToken | null>(null);
    const { orgId } = useOrganization();

    useEffect(() => {
        if (!props.deal?.id) {
            return;
        }
        const generateToken = async () => {
            const newShareToken: ShareToken = {
                readOnly: true,
                orgId: orgId,
                dealId: props.deal?.id || '',
            }
            try {
                const newDoc = await addDoc(collection(firestore, COLLECTIONS.SHARE_TOKENS), newShareToken);
                newShareToken.id = newDoc.id;
                setToken(newShareToken);
            } catch (e) {
                console.error('Error generating token', e);
                toast.error(text.defaultError);
            }
        }

        generateToken();
    }, [firestore, props.deal?.id, orgId, text.defaultError]);


    const link = createShareTokenLink(token?.id || '');

    const handleReadonlyChange = () => {
        if (!token?.id) {
            return;
        }
        const update: Partial<ShareToken> = {
            readOnly: !token.readOnly
        }
        setToken({ ...token, readOnly: !token.readOnly })
        setDoc(doc(firestore, COLLECTIONS.SHARE_TOKENS, token.id), update, { merge: true })
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(link)
        toast.success(text.linkCoppied);
    }

    return (
        <Modal show={!!props.deal} onHide={props.onHide}>
            <ModalBody className='d-flex flex-column gap-3'>
                <div className='d-flex justify-content-between align-items-start'>
                    <div>

                        <Modal.Title>{text.shareDeal}</Modal.Title>
                        <p className='text-muted small m-0'>{text.shareDescription}</p>
                    </div>
                    <CloseButton onClick={props.onHide} />
                </div>

                {token
                    ? <div className='d-flex flex-column gap-2'>
                        <FormCheck label={text.readonly} type='switch' disabled={true} checked={true} onChange={handleReadonlyChange} />

                        <InputGroup>
                            <FormControl
                                value={link}
                                readOnly
                                onFocus={(e) => e.target.select()}
                                onClick={(e: any) => e.target.select()}
                            />
                            <AdvancedButton icon="bi-copy" variant='outline-primary' onClick={handleCopy} />
                        </InputGroup>
                    </div>
                    : <Spinner />}

                <div className='d-flex justify-content-end'>
                    <button className='btn btn-secondary' onClick={props.onHide}>
                        {text.close}
                    </button>
                </div>

            </ModalBody>
        </Modal>
    )
}
